import React from 'react';
interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}
export function CheckIcon({
  className = '',
  size = 24,
  strokeWidth = 2
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-225">
      <path d="M20 6 9 17l-5-5" data-id="element-226" />
    </svg>;
}
export function XIcon({
  className = '',
  size = 24,
  strokeWidth = 2
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-227">
      <path d="M18 6 6 18" data-id="element-228" />
      <path d="m6 6 12 12" data-id="element-229" />
    </svg>;
}
export function ArrowRightIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-230">
      <path d="M5 12h14" data-id="element-231" />
      <path d="m12 5 7 7-7 7" data-id="element-232" />
    </svg>;
}
export function SparklesIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-233">
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" data-id="element-234" />
      <path d="M5 3v4" data-id="element-235" />
      <path d="M19 17v4" data-id="element-236" />
      <path d="M3 5h4" data-id="element-237" />
      <path d="M17 19h4" data-id="element-238" />
    </svg>;
}
export function BookOpenIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-239">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" data-id="element-240" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" data-id="element-241" />
    </svg>;
}
export function StarIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-242">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-243" />
    </svg>;
}
export function QuoteIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-244">
      <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V21z" data-id="element-245" />
      <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3z" data-id="element-246" />
    </svg>;
}
export function ShieldCheckIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-247">
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" data-id="element-248" />
      <path d="m9 12 2 2 4-4" data-id="element-249" />
    </svg>;
}
export function CheckCircle2Icon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-250">
      <circle cx="12" cy="12" r="10" data-id="element-251" />
      <path d="m9 12 2 2 4-4" data-id="element-252" />
    </svg>;
}
export function PlusIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-253">
      <path d="M5 12h14" data-id="element-254" />
      <path d="M12 5v14" data-id="element-255" />
    </svg>;
}
export function MinusIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-256">
      <path d="M5 12h14" data-id="element-257" />
    </svg>;
}
export function HelpCircleIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-258">
      <circle cx="12" cy="12" r="10" data-id="element-259" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" data-id="element-260" />
      <path d="M12 17h.01" data-id="element-261" />
    </svg>;
}